const i = {
  "application/epub+zip": { extension: ".epub" },
  "application/gzip": { extension: ".gz" },
  "application/java-archive": { extension: ".jar" },
  "application/javascript": { extension: ".js", raw: !0 },
  "application/json": { extension: ".json", raw: !0, language: "json" },
  "application/ld+json": { extension: ".jsonld", raw: !0, language: "json" },
  "application/problem+json": {
    extension: ".json",
    raw: !0,
    language: "json"
  },
  "application/vnd.api+json": { extension: ".json", raw: !0, language: "json" },
  "application/dns-json": { extension: ".json", raw: !0, language: "json" },
  "application/msword": { extension: ".doc" },
  "application/octet-stream": { extension: ".bin" },
  "application/ogg": { extension: ".ogx" },
  "application/pdf": { extension: ".pdf", preview: "object" },
  "application/rtf": { extension: ".rtf", raw: !0 },
  "application/vnd.amazon.ebook": { extension: ".azw" },
  "application/vnd.apple.installer+xml": {
    extension: ".mpkg",
    raw: !0,
    language: "xml"
  },
  "application/vnd.mozilla.xul+xml": {
    extension: ".xul",
    raw: !0,
    language: "xml"
  },
  "application/vnd.ms-excel": { extension: ".xls" },
  "application/vnd.ms-fontobject": { extension: ".eot" },
  "application/vnd.ms-powerpoint": { extension: ".ppt" },
  "application/vnd.oasis.opendocument.presentation": { extension: ".odp" },
  "application/vnd.oasis.opendocument.spreadsheet": { extension: ".ods" },
  "application/vnd.oasis.opendocument.text": { extension: ".odt" },
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": {
    extension: ".pptx"
  },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": {
    extension: ".xlsx"
  },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": {
    extension: ".docx"
  },
  "application/vnd.rar": { extension: ".rar" },
  "application/vnd.visio": { extension: ".vsd" },
  "application/x-7z-compressed": { extension: ".7z" },
  "application/x-abiword": { extension: ".abw" },
  "application/x-bzip": { extension: ".bz" },
  "application/x-bzip2": { extension: ".bz2" },
  "application/x-cdf": { extension: ".cda" },
  "application/x-csh": { extension: ".csh" },
  "application/x-freearc": { extension: ".arc" },
  "application/x-httpd-php": { extension: ".php", raw: !0 },
  "application/x-sh": { extension: ".sh", raw: !0 },
  "application/x-tar": { extension: ".tar" },
  "application/xhtml+xml": { extension: ".xhtml", raw: !0, language: "html" },
  "application/xml": { extension: ".xml", raw: !0, language: "xml" },
  "application/yaml": { extension: ".yaml", raw: !0, language: "yaml" },
  "application/zip": { extension: ".zip" },
  "audio/aac": { extension: ".aac" },
  "audio/midi": { extension: ".midi" },
  "audio/mpeg": { extension: ".mp3", preview: "audio" },
  "audio/ogg": { extension: ".oga" },
  "audio/wav": { extension: ".wav" },
  "audio/webm": { extension: ".weba" },
  "font/otf": { extension: ".otf" },
  "font/ttf": { extension: ".ttf" },
  "font/woff": { extension: ".woff" },
  "font/woff2": { extension: ".woff2" },
  "image/apng": { extension: ".apng", preview: "image", alpha: !0 },
  "image/avif": { extension: ".avif", preview: "image" },
  "image/bmp": { extension: ".bmp", preview: "image" },
  "image/gif": { extension: ".gif", preview: "image", alpha: !0 },
  "image/jpeg": { extension: ".jpg", preview: "image" },
  "image/png": { extension: ".png", preview: "image", alpha: !0 },
  "image/svg+xml": {
    extension: ".svg",
    raw: !0,
    language: "xml",
    preview: "image",
    alpha: !0
  },
  "image/tiff": { extension: ".tiff" },
  "image/vnd.microsoft.icon": { extension: ".ico", preview: "image" },
  "image/webp": { extension: ".webp", preview: "image", alpha: !0 },
  "text/calendar": { extension: ".ics", raw: !0 },
  "text/css": { extension: ".css", raw: !0, language: "css" },
  "text/csv": { extension: ".csv", raw: !0 },
  "text/html": {
    extension: ".html",
    raw: !0,
    language: "html",
    preview: "object"
  },
  "text/javascript": { extension: ".js", raw: !0 },
  "text/plain": { extension: ".txt", raw: !0 },
  "text/xml": { extension: ".xml", raw: !0, language: "xml" },
  "text/yaml": { extension: ".yaml", raw: !0, language: "yaml" },
  "video/3gpp": { extension: ".3gp" },
  "audio/3gpp": { extension: ".3gp" },
  "video/3gpp2": { extension: ".3g2" },
  "audio/3gpp2": { extension: ".3g2" },
  "video/mp2t": { extension: ".ts" },
  "video/mp4": { extension: ".mp4", preview: "video" },
  "video/mpeg": { extension: ".mpeg" },
  "video/ogg": { extension: ".ogv" },
  "video/webm": { extension: ".webm", preview: "video" },
  "video/x-msvideo": { extension: ".avi" }
}, a = Object.entries(i).filter(([, e]) => e == null ? void 0 : e.raw).map(([e]) => e);
function t(e) {
  const n = i[e];
  if (n)
    return n;
  if (e.endsWith("+json"))
    return {
      extension: ".json",
      raw: !0,
      language: "json"
    };
}
function o(e) {
  var n;
  return !!((n = t(e)) != null && n.raw);
}
export {
  t as getMediaTypeConfig,
  o as isTextMediaType,
  i as mediaTypes,
  a as textMediaTypes
};
